/* src/app/timeline-skip/partials/timeline-skip-main/timeline-skip-main.component.scss */
.tipIssue {
  background: #c0392b;
  color: white;
  font-weight: bold;
}
.timelineRoundsContainer {
  display: flex;
  flex-flow: row;
  font-size: 0.65rem;
  margin-left: 17rem;
  width: 80vw;
  overflow-x: scroll;
  overflow-y: hidden;
  position: relative;
}
.timelineRoundsContainer .timelineRound {
  min-height: 50rem;
  margin: 1rem;
  min-width: 17rem;
  z-index: 100;
}
.timelineRoundsContainer .timelineRound .roundHeader {
  background-color: #34495e;
  position: relative;
}
.timelineRoundsContainer .timelineRound .roundHeader.sub {
  background-color: #d35400;
  border-top: 3px solid #34495e;
}
.timelineRoundsContainer .timelineRound .roundHeader {
  color: white;
  border-top: 3px solid #27ae60;
  padding: 1rem;
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}
.timelineRoundsContainer .timelineRound .roundHeader button {
  width: 3rem;
}
.timelineRoundsContainer .timelineRound .roundContainer {
  margin-top: 0.5rem;
  background-color: white;
  padding: 0.5rem;
  height: 100%;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.timelineRoundsContainer .timelineRound .roundContainer.dragover * {
  pointer-events: none;
}
.timelineRoundsContainer .orderContainer {
  background-color: #bdc3c7;
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 0.5rem;
  cursor: grab;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}
.jobStatusName {
  background-color: red;
  padding: 0.2rem;
  color: white;
  font-weight: bold;
}
.drop {
  background-color: pink !important;
}
/*# sourceMappingURL=timeline-skip-main.component.css.map */
